var _rect, _rect2, _rect3, _rect4, _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRevenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#8ac9fe",
    height: 263.03,
    rx: 8.51,
    width: 59.41,
    x: 431.72,
    y: 232.97
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#6cf5c2",
    height: 218.66,
    rx: 8.51,
    width: 59.41,
    x: 333.4,
    y: 277.34
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffe177",
    height: 180.94,
    rx: 8.51,
    width: 59.41,
    x: 235.07,
    y: 315.06
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fe646f",
    height: 121.03,
    rx: 8.51,
    width: 59.41,
    x: 136.74,
    y: 374.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m425.67 144.23a10 10 0 0 1 -.2-19.93l23.53-1.22a10 10 0 0 1 10.47 9.45c.35 6.87-.84 17.36-1.21 24.6a10 10 0 0 1 -19.57 2.18c-30.1 29.27-76.76 63.17-130.27 92-52.18 28.19-111.13 51.69-167.85 61.62a10 10 0 1 1 -3.44-19.69c54.5-9.53 111.37-32.24 161.87-59.48 52.54-28.33 98-61.39 126.67-89.53z",
    fill: "#a79ba7",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.86 63.4a8 8 0 1 1 0-16h62.23a8 8 0 0 1 0 16zm0 83.53a8 8 0 0 1 0-16h62.23a8 8 0 0 1 0 16zm22.52-41.76a8 8 0 0 1 0-16h55.43a8 8 0 0 1 0 16z",
    fill: "#a79ba7",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.65,
    cy: 100.7,
    fill: "#ffc338",
    r: 84.7,
    transform: "matrix(.982 -.189 .189 .982 -15.08 43.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m249.74 81.57a9.42 9.42 0 1 1 -18.81-1c0-.36 0-.12 0-.29 0-.69 0 .62 0-.33a11.27 11.27 0 1 0 -11.27 11.26 30.16 30.16 0 0 1 9.44 58.79v4a9.45 9.45 0 0 1 -18.89 0v-4a30.2 30.2 0 0 1 -20.71-28.6c0-.38 0 0 .05-.92v-.89a9.42 9.42 0 1 1 18.81 1.11v.37.33a11.26 11.26 0 1 0 11.26-11.26 30.16 30.16 0 0 1 -9.44-58.79v-4a9.45 9.45 0 0 1 18.89 0v4a30.18 30.18 0 0 1 20.73 28.65v.77z",
    fill: "#ffe177",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRevenue);
export default __webpack_public_path__ + "static/media/Total Revenue.571032c55c8bbba13dfb1fce3e9f8afb.svg";
export { ForwardRef as ReactComponent };